$(function(){
  $(document).on('click', '.js-btn-submit-register', function() {
    let signUpUrl = $(".form_signup").data('url');
    let firstName = $(".form_signup_input.firstname").val();
    let lastName = $(".form_signup_input.lastname").val();
    let firstNameKata = $(".form_signup_input.firstname_kata").val();
    let lastNameKata = $(".form_signup_input.lastname_kata").val();
    let userEmail =  $(".form_signup_input.email").val();
    let phoneNumber = $(".form_signup_input.phone").val();
    let dateOfBirth = $(".form_signup_input.datebirth").val();
    if (signUpUrl) {
      $.ajax({
        url: `${signUpUrl}`,
        cache: false,
        data: {
          user: {
            first_name: firstName,
            last_name: lastName,
            first_name_kana: firstNameKata,
            last_name_kana: lastNameKata,
            email: userEmail,
            phone: phoneNumber,
            birthday: dateOfBirth,
          }
        },
        beforeSend: (xhr) => {
          const csrfToken = document.querySelector(
            "meta[name='csrf-token']"
          ).content;
          xhr.setRequestHeader("X-CSRF-Token", csrfToken);
        },
        type: "POST",
        dataType: "json",
      }).done(function (response) {
        window.location.href = response?.redirect_to
      })
      .fail(function (error) {
        const messageList = error.responseJSON?.errors;
        commonFunctions.showMessageValidate(messageList);
        handleShowMessageValidate(messageList)
      });
    }
  })

  function handleShowMessageValidate(messageList) {
    const errorLength = Object.keys(messageList).length
    const registerBlock = document.getElementById('register-block');

    const currentHeight = registerBlock?.offsetHeight;
    const newHeight = errorLength * 18;
    if (currentHeight < 690) {
      registerBlock.style.height = `calc(100vh - ${105 - newHeight}px)`;
    }
  }
  $(document).on('click', '.btn_show_password', function(e) {
    var x = document.getElementById("user_password");
    var y = document.getElementById("user_password_confirmation");
    x.type === "password" ? x.type = 'text' : x.type = 'password';
    if (y) {
      y.type === "password" ? y.type = 'text' : y.type = 'password';
    }
  })
});
